export default __webpack_public_path__ + "static/media/payment-method.956ab7d1.svg";